import investigationTypes from "./investigationTypes"

const investigationSorter=()=>  
{
let investigationsArray={}
for (let key in investigationTypes)
    {
    investigationsArray[key]={}
    investigationTypes[key].forEach(element => 
        {
        investigationsArray[key][element] = false
        });
    }

return investigationsArray
}






export default investigationSorter